import "./index.css";
import React, { Fragment } from "react";
import ImagePlaceholder from "../../../../components/ImagePlaceholder";
import { splitSentence } from "../../../../Utils/utils";

export default function OnboardingSitePreview({
  userInput,
  brandData,
  preview,
}) {
  const description = splitSentence(brandData.description);

  return (
    <section className="preview">
      <div className="preview__top-container">
        <h2 className="preview__title">Site preview</h2>
      </div>
      <div className="preview__container">
        <div className="preview__header">
          <img
            src={brandData.logo}
            alt="brand logo"
            className="preview__logo"
          />
          <ul className="preview__list">
            {userInput.navTabs.map((tab, i) => {
              return tab.label === "None" ? null : (
                <li className="preview__list-item" key={i}>
                  {tab.label}
                </li>
              );
            })}
          </ul>
          <div className="preview__burger">
            <span className="preview__burger-line" />
            <span className="preview__burger-line" />
            <span className="preview__burger-line" />
          </div>
        </div>
        <div className="preview__banner">
          {preview ? (
            <Fragment>
              <h4
                className="preview__brand-description"
                style={{
                  "--hex": brandData && brandData.hex,
                  "--text-color": brandData
                    ? brandData.white
                      ? "white"
                      : "black"
                    : "black",
                }}
              >
                {description.map((line, i) => (
                  <span className="preview__line" key={i}>
                    {line}
                  </span>
                ))}
              </h4>
              <img
                src={preview}
                alt="lead media"
                className="preview__lead-media"
              />
            </Fragment>
          ) : (
            <ImagePlaceholder text="No lead media selected" bg={true} />
          )}
        </div>
      </div>
      <p className="preview__disclaimer">
        Please note that the preview may not perfectly reflect the final
        product.
      </p>
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/screens/OnboardingSite/components/OnboardingSitePreview/index.js